// ─────────────────────────────────────────────────────────────────────────────
// FetchState — the two ways this page reports a backend problem.
//
//   ErrorPanel   we have nothing to show. Replaces the content area.
//   ErrorBanner  we have stale content worth keeping on screen. Sits above it.
//
// Both take a message that is already display-safe (nodesService phrases them)
// and both offer Retry, because "try again" is the only useful response to a
// backend that was down a second ago.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "./FetchState.module.css";

const WarnIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 4.5 2.6 20h18.8L12 4.5Z" />
    <path d="M12 10v4.5M12 17.4v.1" />
  </svg>
);

const RetryIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 12a8 8 0 1 1-2.6-5.9" />
    <path d="M20 4v4.5h-4.5" />
  </svg>
);

export function ErrorPanel({ message, onRetry, title = "Couldn't load nodes" }) {
  return (
    <div className={styles.panel} role="alert">
      <span className={styles.panelIcon}><WarnIcon size={26} /></span>
      <div className={styles.panelTitle}>{title}</div>
      <p className={styles.panelText}>{message}</p>
      {onRetry && (
        <button type="button" className={styles.retry} onClick={onRetry}>
          <RetryIcon /> Try again
        </button>
      )}
    </div>
  );
}

export function ErrorBanner({ message, onRetry }) {
  return (
    <div className={styles.banner} role="status">
      <span className={styles.bannerIcon}><WarnIcon size={16} /></span>
      <span className={styles.bannerText}>{message}</span>
      {onRetry && (
        <button type="button" className={styles.bannerRetry} onClick={onRetry}>
          <RetryIcon /> Retry
        </button>
      )}
    </div>
  );
}
